import { isRejectedWithValue } from "@reduxjs/toolkit";
import type { MiddlewareAPI, Middleware, AnyAction } from "@reduxjs/toolkit";
import { toPersian } from "utils/text";
import { appActions } from "./app/app.slice";
import { logout } from "./current-user/current-user.thunk";

export const rtkQueryErrorLogger: Middleware =
  ({ dispatch, getState }: MiddlewareAPI) =>
  (next) =>
  (action) => {
    if (isRejectedWithValue(action)) {
      console.log(JSON.stringify(action));
      let message = action.payload.data?.message;
      if (!message) {
        if (action.payload.status) {
          message = `خطای ${toPersian(action.payload.status.toString())}`;
        } else {
          message = "خطای ناشناخته";
        }
      }
      if (action.payload.status === 401 || action.payload.status === 403) {
        switch (action.meta.arg.endpointName) {
          case "login":
            message = "نام‌کاربری یا رمز عبور اشتباه است";
            break;
          case "verifyOtp":
            message = "کد تأیید اشتباه است";
            break;
          default:
            message = "خطای دسترسی";
            dispatch(logout() as unknown as AnyAction);
        }
      }
      if (
        action.payload.status === 409 &&
        action.meta.arg.endpointName === "createUser"
      ) {
        message = "نام‌کاربری تکراری است";
      }
      dispatch(
        appActions.setSnackbar({ isOpen: true, severity: "error", message })
      );
    }
    return next(action);
  };
